import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { mobile_xl } from '../../../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../../../global/commonStyle';

interface Props {
  isActive?: boolean;
  isProjectTemplate?: boolean;
  isProjectTemplatePreview?: boolean;
}

const OuterDiv = styled.div`
  position: relative;
  display: flex;
  ${mobile_xl(css`
    width: 100%;
  `)}
`;
const LeftSection = styled.div`
  min-width: 424px;
  padding: var(--space-8);
  display: flex;
  flex-direction: column;
  gap: var(--space-32);
  ${mobile_xl(css`
    min-width: unset;
    width: 100%;
    padding-block: var(--space-2) var(--space-96);
    gap: var(--space-24);
  `)}
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-32);
  ${mobile_xl(css`
    gap: var(--space-24);
  `)}
`;

const TitleSection = styled.div<Props>`
  padding-inline: var(--space-12);
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  ${mobile_xl(css<Props>`
    padding-inline: ${({ isProjectTemplate }) => (isProjectTemplate ? 'var(--space-0)' : 'var(--space-12)')};
  `)}
`;

const Heading = styled.p`
  ${Typography.heading_xl_semibold}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const SubHeading = styled.p`
  ${Typography.body_lg}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const Content = styled.div`
  padding-inline: var(--space-12);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;

const ButtonSection = styled.div<Props>`
  padding-inline: var(--space-12);
  width: max-content;
  ${AlignCenter}
  gap: var(--space-16);
  ${mobile_xl(css<Props>`
    gap: var(--space-20);
    ${({ isProjectTemplatePreview }) =>
      isProjectTemplatePreview &&
      css`
        position: absolute;
        bottom: 96px;
        z-index: var(--z-index-999);
        left: 50%;
        transform: translateX(-50%);
      `}
  `)}
`;

const FormBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
`;

const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  .fillColor {
    stroke: var(--text-primary);
  }
  .select {
    .angleDown-icon {
      path {
        stroke: var(--text-primary);
      }
    }
  }
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  span {
    color: var(--accent-error);
  }
`;

const SelectInput = styled.input`
  min-width: -webkit-fill-available;
  padding: var(--space-7) var(--space-12);
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  background-color: var(--background-primary);
  ${Typography.body_lg}
  ::placeholder {
    color: var(--text-placeholder);
  }
  &:focus-visible {
    border-color: var(--brand-primary);
    outline: unset;
  }
`;

const IconDiv = styled.div`
  ${FlexCenter}
  position: absolute;
  right: 12px;
  top: 9px;
  .angleDown-icon {
    transition: transform var(--transition-normal) ease;
  }
  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;

const SelectedText = styled.div`
  position: absolute;
  top: 8px;
  left: 12px;
  pointer-events: none;
  color: var(--text-primary);
  ${Typography.body_lg}
`;

const ItemDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
`;

const NotFound = styled.div`
  padding: var(--space-4) var(--space-10);
  border-radius: var(--border-radius-4);
  ${Typography.body_md}
  color: var(--text-secondary);
`;

const ViewSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

const ViewTab = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;

const SkipButton = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding: var(--space-0);
  &:hover {
    color: var(--text-primary);
  }
`;

export {
  OuterDiv,
  LeftSection,
  ButtonSection,
  TopSection,
  TitleSection,
  Heading,
  SubHeading,
  Content,
  FormBlock,
  Form,
  Label,
  SelectInput,
  IconDiv,
  SelectedText,
  ItemDiv,
  ViewSection,
  ViewTab,
  SkipButton,
  NotFound
};
